/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface StatementMatchUpdate
 */
export interface StatementMatchUpdate {
    /**
     * 
     * @type {number}
     * @memberof StatementMatchUpdate
     */
    contactId?: number;
    /**
     * 
     * @type {number}
     * @memberof StatementMatchUpdate
     */
    utteranceId?: number;
    /**
     * 
     * @type {number}
     * @memberof StatementMatchUpdate
     */
    startOffset?: number;
    /**
     * 
     * @type {number}
     * @memberof StatementMatchUpdate
     */
    endOffset?: number;
}

/**
 * Check if a given object implements the StatementMatchUpdate interface.
 */
export function instanceOfStatementMatchUpdate(value: object): boolean {
    return true;
}

export function StatementMatchUpdateFromJSON(json: any): StatementMatchUpdate {
    return StatementMatchUpdateFromJSONTyped(json, false);
}

export function StatementMatchUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatementMatchUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'contactId': json['contactId'] == null ? undefined : json['contactId'],
        'utteranceId': json['utteranceId'] == null ? undefined : json['utteranceId'],
        'startOffset': json['startOffset'] == null ? undefined : json['startOffset'],
        'endOffset': json['endOffset'] == null ? undefined : json['endOffset'],
    };
}

export function StatementMatchUpdateToJSON(value?: StatementMatchUpdate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contactId': value['contactId'],
        'utteranceId': value['utteranceId'],
        'startOffset': value['startOffset'],
        'endOffset': value['endOffset'],
    };
}

